// import React from "react";

// export const Gallery = (props) => {

//   const openInNewTab = (url) => {
//     window.open(url, "_blank", "noreferrer");
//   };

//   const urlRegister = props.data ? "https://app." + props.data.nameBankDomain + ".com/register" : "indefinido";
  
//   return (
//     <div id="gallery">
//       <div className="container">
//         <div className="row d-flex">
//         <div className="col-xs-12 col-md-6">
//             <div className="about-text">
//               <h2>{props.data ? props.data.title : "loading..."}</h2>
//               <button className="btn btn-custom btn-outlined-white btn-lg page-scroll" onClick={() => openInNewTab(urlRegister)}>
//                   Abra sua conta
//                 </button>
//             </div>
//         </div>
//         <div className="col-xs-12 col-md-6">
//           {" "}
//           <img src="img/aeja-arco.png" className="img-responsive" alt="" />{" "}
//         </div>
//         </div>
//       </div>
//     </div>
//   );
// };

import React, { useEffect } from "react";

export const Gallery = (props) => {

  const openInNewTab = (url) => {
    window.open(url, "_blank", "noreferrer");
  };

  const urlRegister = props.data ? "https://app." + props.data.nameBankDomain + ".com.br/register" : "indefinido";

  // IntersectionObserver para animação
  useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
          observer.unobserve(entry.target);
        }
      });
    },
    {
      root: null,           // viewport
      rootMargin: '0px',    // sem margem extra
      threshold: 0          // dispara quando qualquer parte do elemento entra na tela
    }
  );

  const elements = document.querySelectorAll("#gallery .reveal");
  elements.forEach((el) => observer.observe(el));

  return () => observer.disconnect();
}, []);


  return (
    <div id="gallery">
      <div className="container">
        <div className="row d-flex">
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2 className="reveal">{props.data ? props.data.title : "loading..."}</h2>
              <button
                className="btn btn-custom btn-outlined-white btn-lg page-scroll reveal"
                onClick={() => openInNewTab(urlRegister)}
              >
                Abra sua conta
              </button>
            </div>
          </div>
          <div className="col-xs-12 col-md-6 gallery-phone-wrap">
            <img
              src="img/aeja-arco.png"
              className="img-responsive gallery-phone reveal"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};
